const tpl = (fields) => ({ page: 'schedules', ...fields })

export const SCHEDULE_TEMPLATES_PART01 = [
  tpl({
    id: 'demo-tpl-sch-standup',
    title: 'Daily stand-up digest',
    category: 'Engineering',
    cron: '30 9 * * 1-5',
    apps: ['GitHub', 'Slack'],
    description: 'What the team merged, opened, and got stuck on since yesterday — posted before stand-up.',
    steps: [
      'Collect pull requests merged and opened in the last 24 hours',
      'Flag anything waiting on review for more than a day',
      'Post a three-section digest to your team channel',
    ],
    prompt:
      'Every weekday at 9:30, summarise what my team merged and opened on GitHub in the last 24 hours, flag pull requests waiting on review for more than a day, and post the digest to Slack #eng-standup.',
  }),
  tpl({
    id: 'demo-tpl-sch-renewals',
    title: 'Renewals in the next 60 days',
    category: 'Sales',
    cron: '0 9 * * 1',
    apps: ['HubSpot', 'Gmail'],
    description: 'Every Monday, the customers up for renewal soon, with health signals and a suggested next step.',
    steps: [
      'Find HubSpot companies with a renewal date in the next 60 days',
      'Check the latest email thread and any open support issues',
      'Suggest one owner action per account',
    ],
    prompt:
      'Every Monday at 9:00, list HubSpot customers whose renewal date is in the next 60 days with ARR, owner, last contact date, and any open support issues from Gmail, and suggest a next step for each.',
  }),
  tpl({
    id: 'demo-tpl-sch-week-ahead',
    title: 'Week-ahead calendar review',
    category: 'Ops',
    cron: '0 17 * * 5',
    apps: ['Google Calendar'],
    description: 'A Friday-evening look at next week: conflicts, meetings with no agenda, and missing focus time.',
    steps: ['Read next week’s calendar', 'Flag double-bookings and agenda-less meetings', 'Suggest what to decline or move'],
    prompt:
      'Every Friday at 17:00, review my Google Calendar for next week: flag double-bookings, meetings without an agenda, and days with no focus time, and suggest what to decline or move.',
  }),
]
